var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center v-center",attrs:{"fluid":"","right":""}},[_c('v-img',{attrs:{"src":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }